import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import appHistory from '../app/appHistory';
import appReducer from '../app/appReducer';
import accountReducer from '../modules/Account/accountReducer';
import bonusesReducer from '../modules/Bonus/bonusesReducer';
import liteTradeReducer from '../modules/LiteTrade/liteTradeReducer';
import notificationsReducer from '../modules/Notifications/notificationsReducer';
import depositReducer from '../modules/Deposit/depositReducer';
import settingsReducer from '../modules/Settings/settingsReducer';
import achievementsReducer from '../modules/Achievements/achievementsReducer';
import { IMobileAppRootState } from './types/mobileAppState.t';
import internetConnectionReducer from '../modules/InternetConnection/internetConnectionReducer';
import withdrawalReducer from '../modules/Withdrawal/withdrawalReducer';
import websocketReducer from '../providers/WebSocketProvider/websocketReducer';
import tutorialsReducer from '../modules/Tutorials/tutorialsReducer';
import integrationsReducer from '../modules/Integrations/integrationsReducer';
import userReducer from '../app/userReducer';
import pwaReducer from '../modules/Pwa/pwaReducer';
import locationReducer from '../modules/Location/locationReducer';
import bannersReducer from "../modules/Banners/bannersReducer";
import assetTabsReducer from "../modules/AssetTabs/assetTabsReducer";
import alertsReducer from "../modules/Alerts/alertsReducer";
import referralReducer from "../modules/Referral/referralReducer";
import animationReducer from "../modules/Animation/animationReducer";
import userHintsReducer from "../modules/UserHints/userHintsReducer";
import colorThemeReducer from "../modules/ColorTheme/colorThemeReducer";
import demoLimitsReducer from "../modules/DemoLimits/demoLimitsReducer";
import academyReducer from "../modules/Academy/academyReducer";
import leaderboardReducer from "../modules/Leaderboard/leaderboardReducer";

const mobileAppRootReducers = combineReducers<IMobileAppRootState>({
    router: connectRouter(appHistory),

    academy: academyReducer,
    account: accountReducer,
    achievements: achievementsReducer,
    alerts: alertsReducer,
    animation: animationReducer,
    app: appReducer,
    assetTabs: assetTabsReducer,
    banners: bannersReducer,
    bonuses: bonusesReducer,
    colorTheme: colorThemeReducer,
    demoLimits: demoLimitsReducer,
    deposit: depositReducer,
    integrations: integrationsReducer,
    internetConnection: internetConnectionReducer,
    liteTrade: liteTradeReducer,
    location: locationReducer,
    leaderboard: leaderboardReducer,
    notifications: notificationsReducer,
    pwa: pwaReducer,
    referral: referralReducer,
    settings: settingsReducer,
    tutorials: tutorialsReducer,
    user: userReducer,
    userHints: userHintsReducer,
    websocket: websocketReducer,
    withdrawal: withdrawalReducer,
});

export default mobileAppRootReducers;
